// Who sees the new /reports dashboards (solicitudes / órdenes de compra) and
// which cost centers they can query, from initData.centros_costo_vista.

// Cost center that grants the full view (every cost center and área), the
// same one that already unlocks the full view in the legacy screens
export const CENTRO_COSTO_REPORTES = 29;

export interface AlcanceReportes {
  // true: cost center 29 -> no restriction
  total: boolean;
  // cost centers the user can see (centros_costo_vista)
  centros: number[];
}

/**
 * centros_costo_vista as a list of ids. Accepts an array (numbers or strings)
 * or a comma-separated string; anything missing / unexpected means none.
 */
export const centrosCostoVista = (initData: unknown): number[] => {
  const vista = (initData as { centros_costo_vista?: unknown } | null)
    ?.centros_costo_vista;
  const ids: unknown[] = Array.isArray(vista)
    ? vista
    : typeof vista === "string"
      ? vista.split(",")
      : [];
  return Array.from(
    new Set(
      ids
        .map((id) => Number(String(id).trim()))
        .filter((id) => Number.isInteger(id) && id > 0),
    ),
  );
};

export const alcanceReportes = (initData: unknown): AlcanceReportes => {
  const centros = centrosCostoVista(initData);
  return { total: centros.includes(CENTRO_COSTO_REPORTES), centros };
};

/**
 * Any user with at least one cost center in centros_costo_vista gets the new
 * dashboards (scoped to those cost centers unless they have 29). Users with
 * none keep the legacy screens, since there would be nothing to show.
 */
export const puedeVerReportes = (initData: unknown): boolean =>
  centrosCostoVista(initData).length > 0;

// Users who see every titular -> subrogante pair (gerencia general and its
// subrogante). Everyone else only sees the pairs they belong to.
export const USUARIOS_SUBROGANCIA_COMPLETA = [81, 65];

export const veSubroganciaCompleta = (idUsuario: number | undefined) =>
  !!idUsuario && USUARIOS_SUBROGANCIA_COMPLETA.includes(idUsuario);
